import React from 'react'
import { appHistory, browserHistoryEmitter } from '@core/Utils/routing/history'
import { KAMBI_BET_HISTORY_HASH_ROUTE } from '@core/Areas/KambiClient/constants'

export const useShowTransactionTabs = (): boolean => {
  const [shouldShowTransactionTabs, setShouldShowTransactionTabs] = React.useState(evaluateState)

  // Shows racing/sports transaction tabs on bet history route
  React.useEffect(() => {
    const dispose = appHistory.listen(() => {
      setShouldShowTransactionTabs(evaluateState)
    })

    const handleUrlChange = (url: string) => {
      if (!url) return
      setShouldShowTransactionTabs(url.includes(KAMBI_BET_HISTORY_HASH_ROUTE))
    }
    browserHistoryEmitter.on('pushState', handleUrlChange)
    return () => {
      dispose()
      browserHistoryEmitter.off('pushState', handleUrlChange)
    }
  }, [])

  return shouldShowTransactionTabs
}

// =============
// Local Helpers
// =============

function evaluateState() {
  const isBetHistory = appHistory.location.pathname.includes(KAMBI_BET_HISTORY_HASH_ROUTE)
  return isBetHistory
}
